import { render, staticRenderFns } from "./MemberReward.vue?vue&type=template&id=270426a5&"
import script from "./MemberReward.vue?vue&type=script&lang=js&"
export * from "./MemberReward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports